// Unpublished Work © 2025-2026 Deere & Company.

import {SET_SELECTED_ORGANIZATION, SET_SELECTED_DBS, RESET_SELECTED_CONTEXT} from '../action-list';
import {SelectedContext} from '../state/struct/selected-context';

const setSelectedOrganization = (state, action) => SelectedContext.update(state, {
    selectedOrganization: {
        $set: action.selectedOrganization
    }
});

const setSelectedDBS = (state, action) => SelectedContext.update(state, {
    selectedDBS: {
        $set: action.selectedDBS
    }
});

const resetSelectedContext = () => new SelectedContext({});

export function selectedContextReducer(state = new SelectedContext({}), action = {}) {
    const actionHandlers = {
        [SET_SELECTED_ORGANIZATION]: setSelectedOrganization,
        [SET_SELECTED_DBS]: setSelectedDBS,
        [RESET_SELECTED_CONTEXT]: resetSelectedContext
    };
    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
